import { useDeferredValue, useEffect, useRef, useState } from 'react';

export const useDebouncedValue = <T>(value: T, timeoutMs = 800) => {
  const deferredValue = useDeferredValue(value);
  const [debouncedValue, setDebouncedValue] = useState<T>();
  const mounted = useRef(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (mounted.current) {
      timeout = setTimeout(() => {
        setDebouncedValue(deferredValue);
      }, timeoutMs);
    } else {
      mounted.current = true;
    }

    return () => clearTimeout(timeout);
  }, [deferredValue, timeoutMs]);

  return debouncedValue;
};
